import React from "react";
import { Process } from "../../../../api/recipeSimulator";
import RecipeVariantConfirmModal from "./RecipeVariantConfirmModal";
import RecipeAddIngredientModal from "../../recipeAddIngredient/RecipeAddIngredientModal";
import RecipeAddProcessingStepModal from "../../recipeAddProcessingStep/RecipeAddProcessingStepModal";
import RecipeEditProcessingStepModal from "../../recipeAddProcessingStep/RecipeEditProcessingStepModal";
import RecipeViewProcessingStepModal from "../../recipeAddProcessingStep/RecipeViewProcessingStepModal";
import AddRecipeVariantModal from "../AddRecipeVariantModal";
import UpdateRecipeModal from "../UpdateRecipeModal";
import UpdateRecipeVariantModal from "../UpdateRecipeVariantModal";

type ManageRecipeVariantModalsProps = {
  recipeId: string;
  recipeData: any;
  recipeDataRefetch: () => void;
  genericProcess: any;
  usedColors: string[];
  isViewOnly: boolean;
  isOriginal: boolean;
  variantId: string | null;
  selectedProcess: Process | null;
  deleteIngredient: any | null;
  deleteVariant: any | null;
  visibleModal: boolean;
  visibleUpdateModal: boolean;
  visibleRecipeUpdateModal: boolean;
  ingredientVisibleModal: boolean;
  processingStepVisibleModal: boolean;
  processingStepViewModal: boolean;
  processingStepEditModal: boolean;
  setVisibleModal: (visible: boolean) => void;
  setVisibleUpdateModal: (visible: boolean) => void;
  setVisibleRecipeUpdateModal: (visible: boolean) => void;
  setIngredientVisibleModal: (visible: boolean) => void;
  setProcessingStepVisibleModal: (visible: boolean) => void;
  setProcessingStepViewModal: (visible: boolean) => void;
  setProcessingStepEditModal: (visible: boolean) => void;
  setVariantId: (id: string | null) => void;
  setSelectedProcess: (process: Process | null) => void;
  setDeleteIngredient: (ingredient: any | null) => void;
  setDeleteVariant: (value: any | null) => void;
  handleDeleteIngredient: () => void;
  deleteVariants: () => void;
};

const ManageRecipeVariantModals = ({
  recipeId,
  recipeData,
  recipeDataRefetch,
  genericProcess,
  usedColors,
  isViewOnly,
  isOriginal,
  variantId,
  selectedProcess,
  deleteIngredient,
  deleteVariant,
  visibleModal,
  visibleUpdateModal,
  visibleRecipeUpdateModal,
  ingredientVisibleModal,
  processingStepVisibleModal,
  processingStepViewModal,
  processingStepEditModal,
  setVisibleModal,
  setVisibleUpdateModal,
  setVisibleRecipeUpdateModal,
  setIngredientVisibleModal,
  setProcessingStepVisibleModal,
  setProcessingStepViewModal,
  setProcessingStepEditModal,
  setVariantId,
  setSelectedProcess,
  setDeleteIngredient,
  setDeleteVariant,
  handleDeleteIngredient,
  deleteVariants
}: ManageRecipeVariantModalsProps) => (
  <>
    <AddRecipeVariantModal
      open={visibleModal}
      onOpenChange={setVisibleModal}
      recipeId={recipeId}
      recipeDataRefetch={recipeDataRefetch}
    />
    <UpdateRecipeVariantModal
      open={visibleUpdateModal}
      onOpenChange={open => {
        setVisibleUpdateModal(open);
        if (!open) {
          setVariantId(null);
        }
      }}
      recipeId={recipeId}
      variantId={variantId}
      recipeDataRefetch={recipeDataRefetch}
    />
    {visibleRecipeUpdateModal ? (
      <UpdateRecipeModal
        closeModal={() => {
          setVisibleRecipeUpdateModal(false);
        }}
        recipeId={recipeId}
      />
    ) : null}
    {ingredientVisibleModal ? (
      <RecipeAddIngredientModal
        visibleModal={ingredientVisibleModal}
        setVisibleModal={setIngredientVisibleModal}
        recipeId={recipeId}
        recipeDataRefetch={recipeDataRefetch}
        usedColors={usedColors}
        calculatedProductSalesUnit={recipeData?.originalRecipe?.calculatedProductSalesUnit || []}
        genericIngredient={recipeData?.originalRecipe?.genericIngredient || []}
        calculatedIngredient={recipeData?.originalRecipe?.calculatedIngredient || []}
      />
    ) : null}
    {processingStepVisibleModal ? (
      <RecipeAddProcessingStepModal
        visibleModal={processingStepVisibleModal}
        setVisibleModal={setProcessingStepVisibleModal}
        recipeDataRefetch={recipeDataRefetch}
        variantId={variantId}
        setVariantId={setVariantId}
        genericProcess={genericProcess}
        recipeData={recipeData}
        isOriginal={isOriginal}
        usedColors={usedColors}
      />
    ) : null}
    {selectedProcess ? (
      <RecipeViewProcessingStepModal
        visibleModal={processingStepViewModal}
        setVisibleModal={setProcessingStepViewModal}
        process={selectedProcess}
        isOriginal={isOriginal}
        recipeDataRefetch={recipeDataRefetch}
        variantId={variantId}
        setVariantId={setVariantId}
        genericProcess={genericProcess}
        readOnly={isViewOnly}
      />
    ) : null}
    {selectedProcess ? (
      <RecipeEditProcessingStepModal
        visibleModal={processingStepEditModal}
        setVisibleModal={setProcessingStepEditModal}
        process={selectedProcess}
        setSelectedProcess={setSelectedProcess}
        isOriginal={isOriginal}
        recipeDataRefetch={recipeDataRefetch}
        variantId={variantId}
        setVariantId={setVariantId}
        genericProcess={genericProcess}
      />
    ) : null}
    <RecipeVariantConfirmModal
      viewModal={Boolean(deleteIngredient || deleteVariant)}
      closeModal={() => {
        setDeleteIngredient(null);
        setDeleteVariant(false);
      }}
      cancel={() => (deleteIngredient ? setDeleteIngredient(null) : setDeleteVariant(false))}
      approve={deleteIngredient ? handleDeleteIngredient : deleteVariants}
      title={
        deleteIngredient
          ? `Delete ${deleteIngredient?.ingredientName ?? ""} Ingredient`
          : "Delete Variant"
      }
      subTitle={
        deleteIngredient
          ? `Are you sure you want to remove the ${
              deleteIngredient?.ingredientName ?? ""
            } ingredient? This action cannot be undone.`
          : "Are you sure you want to remove this variant? This action cannot be undone."
      }
    />
  </>
);

export default ManageRecipeVariantModals;
